var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3193 8.72979L13.5868 10.9973L13.5976 10.8785C13.5976 9.68716 12.6294 8.71899 11.4381 8.71899L11.3193 8.72979Z",
    fill: "#A6A6A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4381 7.27931C13.4248 7.27931 15.0373 8.89175 15.0373 10.8785C15.0373 11.3428 14.9437 11.7855 14.7817 12.1922L16.8872 14.2977C17.9742 13.3907 18.8308 12.2174 19.3599 10.8785C18.111 7.71843 15.0409 5.47974 11.4381 5.47974C10.4303 5.47974 9.46577 5.65968 8.56958 5.98361L10.1244 7.53484C10.5311 7.37649 10.9738 7.27931 11.4381 7.27931Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.23984 5.31769L5.88107 6.95891L6.2086 7.28645C5.02088 8.21504 4.08149 9.44957 3.52002 10.8784C4.76535 14.0385 7.83903 16.2772 11.4382 16.2772C12.554 16.2772 13.6193 16.0612 14.5947 15.6689L14.9006 15.9748L16.999 18.0768L17.9168 17.1626L5.15763 4.3999L4.23984 5.31769ZM8.22055 9.29479L9.3327 10.4069C9.3003 10.5617 9.27871 10.7165 9.27871 10.8784C9.27871 12.0698 10.2469 13.0379 11.4382 13.0379C11.6002 13.0379 11.755 13.0163 11.9061 12.9839L13.0183 14.0961C12.5396 14.3336 12.0069 14.4776 11.4382 14.4776C9.45147 14.4776 7.83903 12.8652 7.83903 10.8784C7.83903 10.3098 7.98301 9.77707 8.22055 9.29479Z",
    fill: "#A6A6A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseEye);
export default __webpack_public_path__ + "static/media/close-eye.5ac6e0f07a3663bd75741c0908914005.svg";
export { ForwardRef as ReactComponent };